export class HttpError extends Error {
    public userMessage: string;
    public path?: string;

    constructor(message = "", userMessage = "", path?: string) {
        super(message);
        this.userMessage = userMessage;
        this.path = path;
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
